import {combineReducers} from 'redux';

const createReducer = (initialState, handlers, internalReducers) => {
  return (state = initialState, action) => {
    let combinedState = state;

    if (internalReducers) {
      const internalState = Object.keys(internalReducers).reduce((state, reducer) =>
        Object.assign(state, {[reducer]: state[reducer]})
      , {});
      const combinedReducers = combineReducers(internalReducers);
      const commonState = combinedReducers(internalState, action);
      combinedState = {...state, ...commonState};
    }

    if (action && handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](combinedState, action);
    }

    return combinedState;
  };
};

export const createFormReducer = (initialState, formActionName, data) => {
  return createReducer(initialState, getActionsObject(formActionName, data));
};

export const createInlineFormReducer = (initialState, formName, {messages, ActionTypes}) => {
  return createReducer(initialState, {
    ...getActionsObject(`CREATE_${formName}`, {
      ActionTypes,
      'success': messages.createSuccess,
      'failed': messages.createFailed,
    }),
    ...getActionsObject(`UPDATE_${formName}`, {
      ActionTypes,
      'success': messages.updateSuccess,
      'failed': messages.updateFailed,
    }),
  });
};

export function getActionsObject(actionName, {success, failed, ActionTypes, keepValues}) {
  return {
    [ActionTypes[`${actionName}_REQUEST`]]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes[`${actionName}_SUCCESS`]]: (state, action) => ({
      ...state,
      'form': null,
      'loading': false,
      'successMessage': success,
      'values': keepValues ? state.values : null,
    }),
    [ActionTypes[`${actionName}_FAILED`]]: (state, action) => ({
      ...state,
      'loading': false,
      'errorMessage': failed,
    }),
  };
}

export default createReducer;
